const inputDefaults = {
  defaultProps: { focusBorderColor: "brand.500" },
};

const input = inputDefaults;
const select = inputDefaults;
const numberInput = inputDefaults;
const textarea = inputDefaults;

export { input, select, numberInput, textarea };
